<div class="upload-content">
  <div>
    <div class="drop-section">
      <div class="file-item" *ngFor="let file of files; let i = index">
        <img
          *ngIf="canShowPreview(file.url)"
          [src]="file.url"
          [alt]="'arquivo de anexo ' + (i + 1)"
          class="uploaded-image"
        />

        <!-- Exibir ícone genérico para outros tipos de arquivos -->
        <img
          *ngIf="!canShowPreview(file.url)"
          src="../../../../assets/images/pdf-logo.png"
          [alt]="'aquivo de anexo ' + i"
          class="cv-document"
        />

        <div class="btn-remover">
          <button
            [disabled]="!canShowPreview(file.url)"
            class="btn btn-danger btn-sm"
            (click)="openPreviewModal(file.url)"
          >
            <span class="mdi mdi-eye-outline"></span>
          </button>

          <button
            class="btn btn-danger btn-sm"
            (click)="downloadFile(file.attachId)"
          >
            <span class="mdi mdi-download-outline"></span>
          </button>
        </div>
      </div>

      <div *ngIf="files.length === 0">
        <p class="mb-0" style="line-height: 80px">Nenhum anexo encontrado.</p>
      </div>
    </div>

    <!-- Modal para exibir a imagem -->

    <app-new-modal
      [modalOpen]="preview && !!previewUrl"
      (closeModalEvent)="closePreviewModal()"
    >
      <div class="pdf-content" (keydown)="onModalKeyDown($event)">
        <img
          *ngIf="!!previewUrl"
          [src]="previewUrl"
          alt="anexo de desligamento"
          class="uploaded-image"
        />
      </div>
    </app-new-modal>
  </div>
</div>
